import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../../components/shapes/Line'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import RelatedReplies from './RelatedReplies'
import Reply from './Reply'
import Separator from '../../../../components/helpers/Separator'

const Replies = ({ mainReply }) => {
  return (
    <FlexGrid justify="flex-start">
      <FlexCol flex={1}>
        <Separator weight={2} />
        <HorizontalLine thin lineColor={COLORS.light3} />
        <Separator weight={2} />
        <Reply item={mainReply} />
        <Separator weight={2} />
        <RelatedReplies reply={mainReply} />
        <Separator weight={4} />
      </FlexCol>
    </FlexGrid>
  )
}

export default Replies
